export const LISTING_SIMILAR_MODAL_ITEM_COUNT = 10
